(() => {
  if (customElements.get('demax-avvisami-language')) return;
  const targets = '.email-me-button,#email-me-frame,.successSub';
  class DemaxAvvisamiLanguage extends HTMLElement {
    connectedCallback() {
      this.apply = this.apply.bind(this);
      this.observer = new MutationObserver(records => {
        const relevant = records.some(record => {
          const node = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          return node?.closest(targets) || [...record.addedNodes].some(n => n.nodeType === 1 && (n.matches(targets) || n.querySelector(targets)));
        });
        if (relevant) this.apply();
      });
      this.observer.observe(document.body, {childList:true,subtree:true,characterData:true});
      document.addEventListener('shopify:section:load', this.apply);
      this.apply();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('shopify:section:load', this.apply);
    }
    apply() {
      if (!this.isConnected) return;
      const text = (selector, value) => document.querySelectorAll(selector).forEach(el => {
        if (el.textContent.trim() !== value) el.textContent = value;
      });
      text('.email-me-inlineButton,.email-me-floatingButton', this.dataset.title);
      text('#email-me-frame .frame-title', this.dataset.title);
      text('#email-me-frame .email-me-submitButton', this.dataset.submit);
      text('#email-me-frame .email-footer-tips span', this.dataset.footer);
      text('.successSub .successSub_header_text', this.dataset.successTitle);
      text('.successSub .successSub_text', this.dataset.successBody);
      const input = document.querySelector('#email-me-frame .buyer-email');
      if (input && input.placeholder !== this.dataset.email) input.placeholder = this.dataset.email;
      document.querySelectorAll('#email-me-frame .invalid-email-tips').forEach(el => {
        const current = el.textContent.trim();
        // Translate only known app responses; preserve unknown errors verbatim.
        if (/^\*?\s*(Sei già iscritto a questo prodotto\.|You are already subscribed to this product\.?)$/i.test(current)) {
          if (current !== '* ' + this.dataset.duplicate) el.textContent = '* ' + this.dataset.duplicate;
        } else if (/^\*?\s*(Le tue informazioni di contatto non sono valide|Your contact information is invalid)\.?$/i.test(current)) {
          el.textContent = '* ' + this.dataset.invalid;
        }
      });
    }
  }
  customElements.define('demax-avvisami-language', DemaxAvvisamiLanguage);
})();
